import { TotemImage } from 'components/TotemImage';
import { DetailValue } from 'components/DetailsView';
import { GetDetailedSupplierQuery } from 'data/__generated__';

import { getOdooBaseUrl } from 'helpers/odoo';

import { ODOO_COMPANY_LABELS } from '../constants/labels';
import { OdooFields } from './OdooSection';

export const SupplierOdooAssociation = ({ supplier }: { supplier?: GetDetailedSupplierQuery['detailedSupplier'] }) => {
    const odooBaseUrl = getOdooBaseUrl();
    const odooSupplierUrl =
        supplier?.odooSupplierUrl ||
        `${odooBaseUrl}/web#id=${supplier?.odooSupplierId}&model=res.partner&view_type=form`;
    return (
        <>
            {supplier ? (
                <>
                    <DetailValue label="Entité juridique acheteuse" value={ODOO_COMPANY_LABELS[supplier.odooCompany]} />
                    <DetailValue
                        label="Société Odoo"
                        value={
                            <a
                                href={odooSupplierUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2.5 text-primary hover:underline"
                                data-test="supplier-odoo-link"
                            >
                                <TotemImage
                                    src="https://odoo.neocorner.fr/web/static/img/favicon.ico"
                                    alt="Logo Odoo"
                                    size={30}
                                />
                                <span>Fournisseur Odoo #{supplier.odooSupplierId}</span>
                            </a>
                        }
                    />
                </>
            ) : (
                <OdooFields stacked />
            )}
        </>
    );
};
